import { useEffect, useState } from "react";
import useCredencialesNotificadores from "../../../api/credencialesNotificadores";
import { Modal, MuniSpinner2 } from "../../../components";
import { useCredencialesNotificadoresStore } from "../../../store/credencialesNotificadoresStore";
import { useGeneralAppStore } from "../../../store/generalAppStore";

const ModalCredencialNotificador = () => {
  //? ESTADOS GLOBALES
  const { modals, loads, handlerModal } = useGeneralAppStore();
  const { credencialNotificador } = useCredencialesNotificadoresStore();
  const {
    generarCredencialNotificador,
    regenerarCredencialNotificador,
    deshabilitarCredencialNotificador,
    habilitarCredencialNotificador,
  } = useCredencialesNotificadores();
  const [pdfTooBig, setPdfTooBig] = useState(false);

  const handlerGenerarCredencial = () => {
    generarCredencialNotificador({ id: credencialNotificador.id });
  };

  const handlerRegenerarCredencial = () => {
    regenerarCredencialNotificador({ id: credencialNotificador.id });
  };

  const handlerDeshabilitarCredencial = () => {
    deshabilitarCredencialNotificador(credencialNotificador.id);
  };

  const handlerHabilitarCredencial = () => {
    habilitarCredencialNotificador({ id: credencialNotificador.id });
  };
  useEffect(() => {
    if (credencialNotificador?.credencial?.file) {
      let src = credencialNotificador.credencial.file;
      let base64str = src.substring(src.indexOf(",") + 1);
      let decoded = atob(base64str);

      // console.log(decoded.length);

      if (decoded.length > 1.5 * 1024 * 1024) {
        setPdfTooBig(true);
      }
    }
  }, [credencialNotificador]);

  return (
    <>
      <Modal
        backdrop={"static"}
        show={modals.includes("credencial_notificador")}
        size={"lg"}
        onHide={() => handlerModal({ modal: false, modalName: "credencial_notificador" })}
        title={() => `Detalle de la credencial`}
      >
        <div className="position-relative">
          {loads.includes("credencial-notificador") && (
            <div
              className="position-absolute h-100 w-100 z-3"
              style={{ backgroundColor: "rgba(255,255,255,0.7)" }}
            >
              <MuniSpinner2 />
            </div>
          )}
        </div>
        {credencialNotificador && (
          <>
            <div className="row">
              <div className="d-flex gap-1">
                <span className="fw-bold text-primary">Estado:</span>
                {!credencialNotificador.deleted_at && !credencialNotificador.qr_token && (
                  <span className="badge rounded-pill text-bg-secondary">
                    Credencial Sin Generar
                  </span>
                )}

                {!credencialNotificador.deleted_at && credencialNotificador.qr_token && (
                  <span className="badge rounded-pill text-bg-success">Credencial Habilitada</span>
                )}

                {credencialNotificador.deleted_at && credencialNotificador.qr_token && (
                  <span className="badge rounded-pill text-bg-danger">
                    Credencial Deshabilitada
                  </span>
                )}
              </div>
            </div>

            <div className="row">
              <div className="d-flex gap-1">
                <span className="fw-bold text-primary">Nombre:</span>
                <span>{credencialNotificador.razon_social}</span>
              </div>
            </div>

            <div className="row">
              <div className="d-flex gap-1">
                <span className="fw-bold text-primary">Documento:</span>
                <span>{credencialNotificador.documento}</span>
              </div>
            </div>

            <div className="row">
              <div className="d-flex gap-1 justify-content-center">
                {!credencialNotificador.deleted_at && !credencialNotificador.qr_token && (
                  <button
                    disabled={loads.includes("generar-credencial-notificador")}
                    className="btn btn-primary"
                    onClick={handlerGenerarCredencial}
                  >
                    Generar Credencial
                  </button>
                )}

                {!credencialNotificador.deleted_at &&
                  credencialNotificador.qr_path &&
                  credencialNotificador.qr_token && (
                    <>
                      <button className="btn btn-primary" onClick={handlerRegenerarCredencial}>
                        Regenerar Credencial
                      </button>
                      <button className="btn btn-danger" onClick={handlerDeshabilitarCredencial}>
                        Deshabilitar Credencial
                      </button>
                    </>
                  )}

                {credencialNotificador.deleted_at &&
                  credencialNotificador.qr_path &&
                  credencialNotificador.qr_token && (
                    <button className="btn btn-success" onClick={handlerHabilitarCredencial}>
                      Habilitar Credencial
                    </button>
                  )}
              </div>
            </div>

            {loads.includes(
              "generar-credencial-notificador",
              "deshabilitar-credencial-notificador",
              "habilitar-credencial-notificador"
            ) && (
              <div
                className="d-flex justify-content-center align-items-center mt-2"
                style={{ backgroundColor: "rgba(255,255,255,0.7)" }}
              >
                <MuniSpinner2 />
              </div>
            )}

            {credencialNotificador.credencial?.file &&
              !loads.includes(
                "generar-credencial-notificador",
                "deshabilitar-credencial-notificador",
                "habilitar-credencial-notificador"
              ) && (
                <>
                  <hr />
                  {pdfTooBig ? (
                    <div className="alert alert-warning d-flex align-items-center" role="alert">
                      <span>
                        Credencial muy pesada para ser visualizada,{" "}
                        <a
                          href={credencialNotificador.credencial.file}
                          download={`credencial-${credencialNotificador.genero}${credencialNotificador.documento}`}
                          className=""
                        >
                          haga click acá
                        </a>{" "}
                        para descargarla.
                      </span>
                    </div>
                  ) : (
                    <>
                      <div className="row px-2">
                        <a
                          href={credencialNotificador.credencial.file}
                          download={`credencial-${credencialNotificador.genero}${credencialNotificador.documento}`}
                          className="text-center mb-3 px-1 d-block align-items-center"
                          style={{ border: "2px #1334c9 dashed" }}
                        >
                          Descargar Credencial
                        </a>
                      </div>
                      <div className="row">
                        <iframe
                          src={credencialNotificador.credencial?.file}
                          height={"600px"}
                          width={"100%"}
                        />
                      </div>
                    </>
                  )}
                </>
              )}
          </>
        )}
      </Modal>
    </>
  );
};
export default ModalCredencialNotificador;
